import React from "react";
import { connect } from "react-redux";

import SubHeader from "./SubHeader";
import FormInput from "../forms/FormInput";
import { setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";
import AlertModal from '../modals/AlertModal';
import Pagination from 'rc-pagination';

class Configuration extends React.Component {
  state = {
    name: this.props.user.userID,
    user: this.props.user,
    isOpenMessage: false,
    isOpenConfirm: false,
    type:1,
    message: "",
    text: "",
    searchName: "",
    configList:[],
    currentPage: 1,
    postsPerPage: 10,
    detailList:[],
    isOpenGroup:false,
    tmpList:[]
  };

  componentDidMount = async () => {
    if (!this.props.auth.isAuthen || (!this.props.auth.isAdmin)) {
      history.push("/");
    } else {
     this.onSearch();
    }
  };
 
  onSearchChange = (name) => {
    this.setState({ searchName:name});
  };

  onSearch = async () => {
    this.props.setLoading(true);
    try{
      const res = await api.get(
        `${uri.GET_CONFIGURATION}?search=${this.state.searchName}`
      );
    if (res.status === 200) {
        this.setState({
          configList: res.data,
          currentPage:1
        });
        this.props.setLoading(false);
      }
    }catch(ex){
      this.setState({
        configList: [],
      });
      this.props.setLoading(false);
    }
  };

  onEdit = async (item) => {
     var newList = this.state.configList.map((obj)=>{
        if(item.ID === obj.ID){
            obj.IsEdit = true;
            let datas = this.state.tmpList;
            datas.push(obj);
            this.setState({tmpList: datas});
        }
        return obj;
     });
     this.setState({configList: newList});
  }
  onSave = async (item) => {
    this.props.setLoading(true);
    try{
      const res = await api.post(
        `${uri.POST_CONFIGURATION}`,item
      );
    if (res.status === 200) {
        this.props.setLoading(false);
      }
    }catch(ex){
      this.props.setLoading(false);
    }


    var newList = this.state.configList.map((obj)=>{
       if(item.ID === obj.ID){
           obj.IsEdit = false;
           const datas =  this.state.tmpList.filter((obj2) => obj2.ID !==  obj.ID);
           this.setState({tmpList: datas});
       }
       return obj;
    });
    this.setState({configList: newList});
 }
 onCancel = async (item) => {
    var newList = this.state.configList.map((obj)=>{
       if(item.ID === obj.ID){
           obj.IsEdit = false;
           this.state.tmpList.map((obj2)=>{
            if(obj.ID === obj2.ID){
                obj.ItemValue = obj2.ItemValue;
                obj.ItemName =  obj2.ItemName;
            }
           });
           const datas =  this.state.tmpList.filter((obj2) => obj2.ID !==  obj.ID);
           this.setState({tmpList: datas});
       }
       return obj;
    });
    this.setState({configList: newList});
 }

 onValueChange = (item, val)=>{
    var newList = this.state.configList.map((obj)=>{
        if(item.ID === obj.ID){
            obj.ItemValue = val
        }
        return obj;
     });
     this.setState({configList: newList});
 }

 onNameChange = (item, val)=>{
    var newList = this.state.configList.map((obj)=>{
        if(item.ID === obj.ID){
            obj.ItemName = val
        }
        return obj;
     });
     this.setState({configList: newList});
 }

  onClose = () =>{
    this.setState({ isOpenDetail: false, isOpenMessage: false, isOpenConfirm:false});
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ currentPage:current });
  }

  render() {
    const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
    const currentPosts = this.state.configList.slice(indexOfFirstPost, indexOfLastPost);
    return (
      <div className="home flex-v">
        <SubHeader text={`Configuration`} />
          <div className="flex-v flex-1">
            <div className="flex-v flex-1 pl-24 pr-24">
              <div
                className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16"
                style={{ borderRadius: "10px" }}
              >
                <FormInput
                  value={this.state.searchName}
                  onValueChange={this.onSearchChange}
                  type="text"
                  placeholder="Name"
                />
                  <div className=" flex-h mt-16 center buttons" >
                      <button onClick={() => this.onSearch()} className="button is-success center" >
                        Search
                      </button>     
                  </div>
              </div>
            </div>
          </div>
        <div className="flex-v text-center p-16 mt-8">
            {this.state.configList.length === 0 ?<div>Data not found.</div>:
              <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th style={{width: '10%'}}>
                                #
                            </th>
                            <th style={{width: '35%'}}>
                                Name
                            </th>
                            <th style={{width: '35%'}}>
                                Value
                            </th>
                            <th style={{width: '20%'}}>
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <td colSpan="7" style={{textAlign:'center'}}>
                            <Pagination className="ant-pagination" 
                              onChange={this.onShowSizeChange}
                              defaultCurrent={1} 
                              pageSize={this.state.postsPerPage} 
                              total={this.state.configList.length} />
                            </td>
                        </tr>
                        </tfoot>
                        <tbody>
                            {currentPosts.map((item, i) =>{
                                return (
                                    <tr key={item.ID}>
                                        <td>
                                            {i+1}
                                        </td>
                                        <td>
                                            {!item.IsEdit && item.ItemName}
                                            {item.IsEdit && <input type="text" value={item.ItemName} onChange={e => {this.onNameChange(item, e.target.value)}} />}
                                        </td>
                                        <td>
                                            {!item.IsEdit && item.ItemValue}
                                            {item.IsEdit && <input type="text" value={item.ItemValue} onChange={e => {this.onValueChange(item, e.target.value)}} />}
                                        </td>
                                        <td>
                                            <div>
                                                {!item.IsEdit && <button onClick={() => this.onEdit(item)} className="button is-small is-info is-outlined">Edit</button>}
                                                {item.IsEdit && <button onClick={() => this.onSave(item)} className="button is-small is-success is-outlined">Save</button>}
                                                {item.IsEdit && <button onClick={() => this.onCancel(item)} className="button is-small is-danger is-outlined ml-8">Cancel</button>}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        
                    </tbody>
                </table>
              </div>
            }
          
        </div>
        <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.doa.user,
  };
};

export default connect(mapStateToProps, {
  setLoading,
})(Configuration);
